import React, { useState, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Button,
  CssBaseline,
  TextField,
  Grid,
  Box,
  Typography,
  InputAdornment,
  IconButton,
  Link,
  Paper
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { LockOutlined, Visibility, VisibilityOff, EmailOutlined } from "@material-ui/icons";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import Logo from "../../components/Logo";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    display: "flex",
  },
  image: {
    backgroundRepeat: "no-repeat",
    backgroundColor: theme.palette.type === "light" ? theme.palette.primary.main : theme.palette.secondary.main,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: "linear-gradient(135deg, #4F46E5 0%, #312E81 100%)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    padding: theme.spacing(4),
  },
  paperContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(8, 4),
    backgroundColor: theme.palette.background.default,
  },
  formWrapper: {
    width: "100%",
    maxWidth: 400,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    width: 64,
    height: 64,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    boxShadow: "0 4px 14px 0 rgba(79, 70, 229, 0.39)",
    marginBottom: theme.spacing(3),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    padding: theme.spacing(1.5),
    fontWeight: 600,
    fontSize: "1rem",
  },
  heroText: {
    textAlign: "center",
    fontWeight: 500,
    opacity: 0.9,
    maxWidth: 480,
    lineHeight: 1.6,
  },
}));

const Copyright = () => (
  <Typography variant="body2" color="textSecondary" align="center" style={{ marginTop: 24 }}>
    {"© "}
    <Link color="inherit" href="#">
      MessaJO - JO Group
    </Link>{" "}
    {new Date().getFullYear()}
    {"."}
  </Typography>
);

const Login = ({ signupEnabled = true, signupStatusLoading = false }) => {
  const classes = useStyles();
  const [user, setUser] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const { handleLogin } = useContext(AuthContext);

  const handleChangeInput = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handlSubmit = (e) => {
    e.preventDefault();
    handleLogin(user);
  };

  return (
    <Grid container className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image}>
        <Logo forceLight style={{ height: 64, marginBottom: 16 }} />
        <Typography variant="h6" className={classes.heroText}>
          {i18n.t("login.heroText")}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square className={classes.paperContainer}>
        <div className={classes.formWrapper}>
          <div className={classes.avatar}>
            <LockOutlined style={{ color: "#fff", fontSize: 32 }} />
          </div>
          <Typography component="h1" variant="h4" style={{ fontWeight: 700, marginBottom: 8, color: "#0F172A" }}>
            {i18n.t("login.title")}
          </Typography>
          <Typography variant="body1" color="textSecondary" style={{ marginBottom: 32 }}>
            {i18n.t("login.subtitle")}
          </Typography>

          <form className={classes.form} noValidate onSubmit={handlSubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label={i18n.t("login.form.email")}
              name="email"
              autoComplete="email"
              autoFocus
              value={user.email}
              onChange={handleChangeInput}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailOutlined color="action" />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label={i18n.t("login.form.password")}
              type={showPassword ? "text" : "password"}
              id="password"
              autoComplete="current-password"
              value={user.password}
              onChange={handleChangeInput}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockOutlined color="action" />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword((show) => !show)}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              {i18n.t("login.buttons.submit")}
            </Button>
            <Grid container justifyContent="flex-end">
              {!signupStatusLoading && signupEnabled && (
                <Grid item>
                  <Link component={RouterLink} to="/signup" variant="body2" color="primary">
                    {i18n.t("login.buttons.register")}
                  </Link>
                </Grid>
              )}
            </Grid>
            <Box mt={5}>
              <Copyright />
            </Box>
          </form>
        </div>
      </Grid>
    </Grid>
  );
};

export default Login;

